<template>
  <form class="js-cm-form" 
        id="subForm" 
        action="https://www.createsend.com/t/subscribeerror?description=" 
        method="post" 
        data-id="5B5E7037DA78A748374AD499497E309E44ED2818FD1CDC3D28A683C8AB27A5081BB2111146BD9FA2E4BE4D06CB9F8F5BCDF13BB178F0745EB177CE2E286389CD">
    <div class="flex flex-col justify-center items-stretch sm:w-1/2 mx-auto">
        <input 
          autocomplete="Email" 
          aria-label="Email" 
          class="js-cm-email-input qa-input-email input mb-2 text-center"
          style="width: auto" 
          id="fieldEmail" 
          maxlength="200" 
          placeholder="your@email.com"
          name="cm-oktkdtl-oktkdtl" required="" type="email">
    <button type="submit" class="p-2 text-sm 
      focus:outline-none
      font-bold font-proxima border border-solid uppercase
      bg-jblue text-white border-jblue
    
    ">Subscribe</button>
    </div>
  </form>
</template>

<script>
export default {

}
</script>